<div style="width:80%; max-width: 780px; margin: 0 auto" >
    <video style="width:100%;height:100%;" width="100%" height="100%" [id]="getPlayerId()" preload="metadata"></video>
</div>
<br/>